import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { getWorkspaceAlertsNavigationAllowed } from "../../../getWorkspaceAlertsNavigationAllowed";

const EditWorkspaceAlertPage = lazy(() =>
  import("@scenes/WorkspaceAlerts").then((module) => ({
    default: module.EditWorkspaceAlertPage,
  }))
);

export const workspaceAlertsEditNRO: NavigationRoutingObject = {
  Component: EditWorkspaceAlertPage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("workspace-alerts-nro-heading", "Workspace Alerts"),
  pageNameForTracking: () => "Workspace Alerts - Edit",
  getDeveloperNavigationAllowed: getWorkspaceAlertsNavigationAllowed,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  // Reached from an alert on the Messaging page.
  showInSearchResults: false,
  defaultRoute: "/app_settings/app_settings/product_alerts/messaging/:appGroupId",
};
